import { FEEDBACK } from "../Action";

const initialState = {
  open: false,
};

const FeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEEDBACK.open:
      return {
        ...state,
        open: action.data,
      };

    default:
      return state;
  }
};

export default FeedbackReducer;
